"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.ConfigContext = void 0;
var react_1 = __importStar(require("react"));
var Loader_1 = require("../components/Loader");
var useBoolean_1 = __importDefault(require("../hooks/useBoolean"));
var promise_1 = require("../utils/promise");
var utils_1 = require("../utils/utils");
var CacheProvider_1 = require("./CacheProvider");
exports.ConfigContext = react_1.createContext({
    apiUrl: '',
    ciselnikyUrl: '',
    iszrUrl: '',
    authUrl: '',
    vypisyUrl: '',
    zasobnikUrl: '',
    zasobnikCiselnikyUrl: '',
    pomuckykUrl: '',
    pomuckyCiselnikykUrl: '',
    pojisteniUrl: '',
    pojisteniCiselnikyUrl: '',
    posudkyUrl: '',
    posudkyCiselnikyUrl: '',
    ukonyUrl: '',
    ukonyCiselnikyUrl: '',
    zadostiUrl: '',
    zadostiCiselnikyUrl: '',
    hlaseni: '',
    pubWeb: '',
});
var useConfig = function () { return react_1.default.useContext(exports.ConfigContext); };
exports.useConfig = useConfig;
var ConfigProvider = function (_a) {
    var children = _a.children, typ = _a.typ;
    var _b = react_1.useState(), error = _b[0], setError = _b[1];
    var _c = react_1.useState({
        apiUrl: '',
        ciselnikyUrl: '',
        iszrUrl: '',
        authUrl: '',
        vypisyUrl: '',
        zasobnikUrl: '',
        zasobnikCiselnikyUrl: '',
        pomuckykUrl: '',
        pomuckyCiselnikykUrl: '',
        pojisteniUrl: '',
        pojisteniCiselnikyUrl: '',
        posudkyUrl: '',
        posudkyCiselnikyUrl: '',
        ukonyUrl: '',
        ukonyCiselnikyUrl: '',
        zadostiUrl: '',
        zadostiCiselnikyUrl: '',
        hlaseni: '',
        pubWeb: '',
    }), config = _c[0], setConfig = _c[1];
    var isLoading = useBoolean_1.default(true);
    var cache = CacheProvider_1.useCache();
    react_1.useEffect(function () {
        var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
            var cacheHit, response, jsonConfig, gateWay, e_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        _q.trys.push([0, 5, 6, 7]);
                        cacheHit = cache === null || cache === void 0 ? void 0 : cache.read('appConfig');
                        if (cacheHit) {
                            return [2 /*return*/, setConfig({
                                    typ: typ,
                                    iszrUrl: utils_1.removeTrailingSlash(cacheHit.ISZR_API),
                                    vypisyUrl: utils_1.removeTrailingSlash(cacheHit.VYPISY_API),
                                    apiUrl: utils_1.removeTrailingSlash(typ === 'tlumocnik' ? cacheHit.TLUMOCNICI_API : cacheHit.ZNALCI_API),
                                    ciselnikyUrl: utils_1.removeTrailingSlash(typ === 'tlumocnik' ? cacheHit.TLUMOCNICI_CISELNIKY : cacheHit.ZNALCI_CISELNIKY),
                                    authUrl: cacheHit.AUTH_API ? utils_1.removeTrailingSlash(cacheHit.AUTH_API) : undefined,
                                    disableAuth: cacheHit.DISABLE_AUTH ? cacheHit.DISABLE_AUTH : false,
                                    adminUrl: cacheHit.ADMIN_API ? utils_1.removeTrailingSlash(cacheHit.ADMIN_API) : undefined,
                                    prostredi: cacheHit.PROSTREDI ? cacheHit.PROSTREDI : undefined,
                                    googleAnalytics: cacheHit.GOOGLE_ANALYTICS ? cacheHit.GOOGLE_ANALYTICS : undefined,
                                    zasobnikUrl: utils_1.removeTrailingSlash(cacheHit.ZASOBNIK_API),
                                    zasobnikCiselnikyUrl: utils_1.removeTrailingSlash(cacheHit.ZASOBNIK_CISELNIKY),
                                    pomuckykUrl: utils_1.removeTrailingSlash(cacheHit.POMUCKY_API),
                                    pomuckyCiselnikykUrl: utils_1.removeTrailingSlash(cacheHit.POMUCKY_CISELNIKY),
                                    pojisteniUrl: utils_1.removeTrailingSlash(cacheHit.POJISTENI_API),
                                    pojisteniCiselnikyUrl: utils_1.removeTrailingSlash(cacheHit.POJISTENI_CISELNIKY),
                                    posudkyUrl: utils_1.removeTrailingSlash(cacheHit.POSUDKY_API),
                                    posudkyCiselnikyUrl: utils_1.removeTrailingSlash(cacheHit.POSUDKY_CISELNIKY),
                                    ukonyUrl: utils_1.removeTrailingSlash(cacheHit.UKONY_API),
                                    ukonyCiselnikyUrl: utils_1.removeTrailingSlash(cacheHit.UKONY_CISELNIKY),
                                    zadostiUrl: utils_1.removeTrailingSlash(cacheHit.ZADOSTI_API),
                                    zadostiCiselnikyUrl: utils_1.removeTrailingSlash(cacheHit.ZADOSTI_CISELNIKY),
                                    hlaseni: cacheHit.HLASENI ? cacheHit.HLASENI : undefined,
                                    pubWeb: cacheHit.PUBWEB ? cacheHit.PUBWEB : undefined,
                                })];
                        }
                        isLoading.setTrue();
                        return [4 /*yield*/, Promise.race([fetch(utils_1.UriKontext() + "/appConfig.json"), promise_1.timeoutRejection()])];
                    case 1:
                        response = _q.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        jsonConfig = _q.sent();
                        gateWay = void 0;
                        if (jsonConfig.GATEWAY_API) {
                            gateWay = utils_1.removeTrailingSlash(jsonConfig.GATEWAY_API);
                            if (!jsonConfig.ISZR_API.startsWith('http'))
                                jsonConfig.ISZR_API = gateWay + jsonConfig.ISZR_API;
                            if (!jsonConfig.VYPISY_API.startsWith('http'))
                                jsonConfig.VYPISY_API = gateWay + jsonConfig.VYPISY_API;
                            if (!jsonConfig.TLUMOCNICI_API.startsWith('http'))
                                jsonConfig.TLUMOCNICI_API = gateWay + jsonConfig.TLUMOCNICI_API;
                            if (!jsonConfig.ZNALCI_API.startsWith('http'))
                                jsonConfig.ZNALCI_API = gateWay + jsonConfig.ZNALCI_API;
                            if (!jsonConfig.TLUMOCNICI_CISELNIKY.startsWith('http'))
                                jsonConfig.TLUMOCNICI_CISELNIKY = gateWay + jsonConfig.TLUMOCNICI_CISELNIKY;
                            if (!jsonConfig.ZNALCI_CISELNIKY.startsWith('http'))
                                jsonConfig.ZNALCI_CISELNIKY = gateWay + jsonConfig.ZNALCI_CISELNIKY;
                            if (!((_a = jsonConfig.AUTH_API) === null || _a === void 0 ? void 0 : _a.startsWith('http')))
                                jsonConfig.AUTH_API = gateWay + jsonConfig.AUTH_API;
                            if (!((_b = jsonConfig.ADMIN_API) === null || _b === void 0 ? void 0 : _b.startsWith('http')))
                                jsonConfig.ADMIN_API = gateWay + jsonConfig.ADMIN_API;
                            if (!((_c = jsonConfig.ZASOBNIK_API) === null || _c === void 0 ? void 0 : _c.startsWith('http')))
                                jsonConfig.ZASOBNIK_API = gateWay + jsonConfig.ZASOBNIK_API;
                            if (!((_d = jsonConfig.ZASOBNIK_CISELNIKY) === null || _d === void 0 ? void 0 : _d.startsWith('http')))
                                jsonConfig.ZASOBNIK_CISELNIKY = gateWay + jsonConfig.ZASOBNIK_CISELNIKY;
                            if (!((_e = jsonConfig.POMUCKY_API) === null || _e === void 0 ? void 0 : _e.startsWith('http')))
                                jsonConfig.POMUCKY_API = gateWay + jsonConfig.POMUCKY_API;
                            if (!((_f = jsonConfig.POMUCKY_CISELNIKY) === null || _f === void 0 ? void 0 : _f.startsWith('http')))
                                jsonConfig.POMUCKY_CISELNIKY = gateWay + jsonConfig.POMUCKY_CISELNIKY;
                            if (!((_g = jsonConfig.POJISTENI_API) === null || _g === void 0 ? void 0 : _g.startsWith('http')))
                                jsonConfig.POJISTENI_API = gateWay + jsonConfig.POJISTENI_API;
                            if (!((_h = jsonConfig.POJISTENI_CISELNIKY) === null || _h === void 0 ? void 0 : _h.startsWith('http')))
                                jsonConfig.POJISTENI_CISELNIKY = gateWay + jsonConfig.POJISTENI_CISELNIKY;
                            if (!((_j = jsonConfig.POSUDKY_API) === null || _j === void 0 ? void 0 : _j.startsWith('http')))
                                jsonConfig.POSUDKY_API = gateWay + jsonConfig.POSUDKY_API;
                            if (!((_k = jsonConfig.POSUDKY_CISELNIKY) === null || _k === void 0 ? void 0 : _k.startsWith('http')))
                                jsonConfig.POSUDKY_CISELNIKY = gateWay + jsonConfig.POSUDKY_CISELNIKY;
                            if (!((_l = jsonConfig.UKONY_API) === null || _l === void 0 ? void 0 : _l.startsWith('http')))
                                jsonConfig.UKONY_API = gateWay + jsonConfig.UKONY_API;
                            if (!((_m = jsonConfig.UKONY_CISELNIKY) === null || _m === void 0 ? void 0 : _m.startsWith('http')))
                                jsonConfig.UKONY_CISELNIKY = gateWay + jsonConfig.UKONY_CISELNIKY;
                            if (!((_o = jsonConfig.ZADOSTI_API) === null || _o === void 0 ? void 0 : _o.startsWith('http')))
                                jsonConfig.ZADOSTI_API = gateWay + jsonConfig.ZADOSTI_API;
                            if (!((_p = jsonConfig.ZADOSTI_CISELNIKY) === null || _p === void 0 ? void 0 : _p.startsWith('http')))
                                jsonConfig.ZADOSTI_CISELNIKY = gateWay + jsonConfig.ZADOSTI_CISELNIKY;
                        }
                        if (cache) {
                            cache.write('appConfig', jsonConfig);
                        }
                        setConfig({
                            typ: typ,
                            iszrUrl: utils_1.removeTrailingSlash(jsonConfig.ISZR_API),
                            vypisyUrl: utils_1.removeTrailingSlash(jsonConfig.VYPISY_API),
                            apiUrl: utils_1.removeTrailingSlash(typ === 'tlumocnik' ? jsonConfig.TLUMOCNICI_API : jsonConfig.ZNALCI_API),
                            ciselnikyUrl: utils_1.removeTrailingSlash(typ === 'tlumocnik' ? jsonConfig.TLUMOCNICI_CISELNIKY : jsonConfig.ZNALCI_CISELNIKY),
                            authUrl: jsonConfig.AUTH_API ? utils_1.removeTrailingSlash(jsonConfig.AUTH_API) : undefined,
                            disableAuth: jsonConfig.DISABLE_AUTH ? jsonConfig.DISABLE_AUTH : false,
                            adminUrl: jsonConfig.ADMIN_API ? utils_1.removeTrailingSlash(jsonConfig.ADMIN_API) : undefined,
                            prostredi: jsonConfig.PROSTREDI ? jsonConfig.PROSTREDI : undefined,
                            googleAnalytics: jsonConfig.GOOGLE_ANALYTICS ? jsonConfig.GOOGLE_ANALYTICS : undefined,
                            zasobnikUrl: utils_1.removeTrailingSlash(jsonConfig.ZASOBNIK_API),
                            zasobnikCiselnikyUrl: utils_1.removeTrailingSlash(jsonConfig.ZASOBNIK_CISELNIKY),
                            pomuckykUrl: utils_1.removeTrailingSlash(jsonConfig.POMUCKY_API),
                            pomuckyCiselnikykUrl: utils_1.removeTrailingSlash(jsonConfig.POMUCKY_CISELNIKY),
                            pojisteniUrl: utils_1.removeTrailingSlash(jsonConfig.POJISTENI_API),
                            pojisteniCiselnikyUrl: utils_1.removeTrailingSlash(jsonConfig.POJISTENI_CISELNIKY),
                            posudkyUrl: utils_1.removeTrailingSlash(jsonConfig.POSUDKY_API),
                            posudkyCiselnikyUrl: utils_1.removeTrailingSlash(jsonConfig.POSUDKY_CISELNIKY),
                            ukonyUrl: utils_1.removeTrailingSlash(jsonConfig.UKONY_API),
                            ukonyCiselnikyUrl: utils_1.removeTrailingSlash(jsonConfig.UKONY_CISELNIKY),
                            zadostiUrl: utils_1.removeTrailingSlash(jsonConfig.ZADOSTI_API),
                            zadostiCiselnikyUrl: utils_1.removeTrailingSlash(jsonConfig.ZADOSTI_CISELNIKY),
                            hlaseni: jsonConfig.HLASENI ? jsonConfig.HLASENI : undefined,
                            pubWeb: jsonConfig.PUBWEB ? jsonConfig.PUBWEB : undefined,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        setError(response.statusText);
                        _q.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1 = _q.sent();
                        setError(e_1.message);
                        return [3 /*break*/, 7];
                    case 6:
                        isLoading.setFalse();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        fetchConfig();
    }, [typ]);
    if (isLoading.value) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    return react_1.default.createElement(exports.ConfigContext.Provider, { value: config }, children);
};
exports.default = ConfigProvider;
